import PropTypes from "prop-types";

export const Address = {
  addressKey: PropTypes.string,
  quickviewAddress: PropTypes.string,
  postcode: PropTypes.string,
};
